export var ExecutionStates;
(function (ExecutionStates) {
    ExecutionStates["EXECUTION_STARTED"] = "EXECUTION_STARTED";
    ExecutionStates["EXECUTION_FINISHED"] = "EXECUTION_FINISHED";
    ExecutionStates["EXECUTION_ERROR"] = "EXECUTION_ERROR";
})(ExecutionStates || (ExecutionStates = {}));
//# sourceMappingURL=ProgramExecution.js.map